export default {
    disconnected: 'disconnected',
    connected   : 'connected',
    connecting  : 'connecting',
};
